// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ask-for-reinforcement .row{row-gap:1rem}\n", ""]);
// Exports
module.exports = exports;
